'use client';

import { useConsents } from '../../providers/consents';

const ConsentSettings = ({ children }) => {
  const { consentSettingsOpen } = useConsents();

  if (!consentSettingsOpen) return null;

  return children;
};

export default ConsentSettings;
